/* Owner hub review block, 2026-10-12. See snippets/ow2-owners-review.liquid.
   Opens Judge.me's write-a-review form once, moves it inline, mirrors our star
   picker into Judge.me's star field, and lets one "Send review" button step
   through Judge.me's own pages so Judge.me does the validation, the
   photo/video upload and the saving. */
(function () {
  var root = document.querySelector('[data-owr]');
  if (!root) return;
  var host = root.querySelector('[data-owr-form]');
  var src = root.querySelector('[data-owr-src]');
  var btn = root.querySelector('[data-owr-submit]');
  var msg = root.querySelector('[data-owr-msg]');
  var stars = [].slice.call(root.querySelectorAll('.owr__star'));
  var M = 'jdgm-write-review-modal';
  var rating = 0;

  function unlock() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }
  function tidy(m) {
    var prompt = m.querySelector('.' + M + '__media-upload-prompt');
    if (prompt && !prompt.dataset.owr) { prompt.dataset.owr = '1'; prompt.textContent = root.getAttribute('data-media-label') || ''; }
  }
  function mount() {
    var m = document.querySelector('.' + M);
    if (m) {
      if (m.parentElement !== host) host.appendChild(m);
      tidy(m);
      root.classList.add('is-ready');
      unlock();
      return true;
    }
    var open = src.querySelector('.jm-button, .jdgm-write-rev-link');
    if (open && !open.dataset.owrClicked) { open.dataset.owrClicked = '1'; open.click(); }
    return false;
  }
  var tries = 0;
  (function wait() {
    if (mount()) { setTimeout(unlock, 60); setTimeout(unlock, 400); return; }
    if (++tries < 120) setTimeout(wait, 250);
  })();

  function judgeStars(sel) { return host.querySelectorAll(sel + ' .jdgm-star'); }
  function score() {
    var i = host.querySelector('.' + M + '__field-group--stars input[name="score"]');
    return i ? i.value : '';
  }
  function paint(n) {
    stars.forEach(function (b, i) {
      b.classList.toggle('is-on', i < n);
      b.setAttribute('aria-checked', i === n - 1 ? 'true' : 'false');
    });
  }
  stars.forEach(function (b, i) {
    b.addEventListener('mouseenter', function () { paint(i + 1); });
    b.addEventListener('mouseleave', function () { paint(rating); });
    b.addEventListener('click', function () {
      rating = i + 1;
      paint(rating);
      msg.textContent = '';
      var intro = judgeStars('.' + M + '__page--review-form-intro');
      if (intro[i]) intro[i].click();
      setTimeout(function () {
        var det = judgeStars('.' + M + '__field-group--stars');
        if (det[i] && String(score()) !== String(rating)) det[i].click();
      }, 350);
    });
  });

  function page() {
    var p = host.querySelector('.' + M + '__page.current-page');
    return p ? p.className : '';
  }
  function done() { root.classList.add('is-done'); msg.textContent = ''; }

  btn.addEventListener('click', function () {
    msg.textContent = '';
    if (!rating || !score()) { msg.textContent = root.getAttribute('data-need-stars') || ''; return; }
    var steps = 0;
    (function step() {
      var before = page();
      if (/thank-you/.test(before)) { done(); return; }
      var next = host.querySelector('.' + M + '__nav-btn-next');
      if (!next) return;
      btn.disabled = true;
      next.click();
      setTimeout(function () {
        btn.disabled = false;
        var after = page();
        if (/thank-you/.test(after)) { done(); return; }
        if (after === before) {
          var errs = [].slice.call(host.querySelectorAll('.' + M + '__field-error')).filter(function (e) { return e.textContent.trim(); });
          if (errs[0]) errs[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        if (++steps < 6) step();
      }, 1200);
    })();
  });
})();
